<template>
  <div>
    <v-data-table
      style="margin-inline: 10px"
      class="elevation-5"
      :headers="getHeaderTable(headers)"
      :items="filteredRows"
      :items-per-page="15"
      @update:page="page = $event"
      @update:items-per-page="itemsPerPage = $event"
    >
      <template v-slot:top>
        <div
          style="
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            padding-inline: 10px;
          "
        >
          <v-text-field
            v-model="search"
            style="width: 40vh; padding-bottom: 5px"
            append-icon="mdi-magnify"
            label="Поиск"
            single-line
            hide-details
          />
          <v-spacer />
          <v-btn
            @click="
              action = 'add';
              selectedNoro = {};
              windowsForEditOrAdd = true;
            "
          >
            Добавить
          </v-btn>
        </div>
      </template>
      <template v-slot:item.action="{ isMobile, index }">
        <td v-bind:class="!isMobile ? 'v-data-table__divider' : ''">
          <v-icon
            small
            class="mdi-pencil"
            color="#00AAAA"
            title="Изменение записи"
            @click="
              selectedNoro = Object.assign({}, searchRowByIndex(index));
              action = 'update';
              windowsForEditOrAdd = true;
            "
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="mdi-delete"
            color="#FF0000"
            title="Удаление записи"
            @click="
              windowForDelete = true;
              delayedFunction = function () {
                deleteNoro(searchRowByIndex(index).id);
              };
            "
          >
            mdi-delete
          </v-icon>
        </td>
      </template>
      <template
        v-for="header in headers"
        v-slot:[`item.${header.value}`]="{ isMobile, item }"
      >
        <td
          :key="header.value"
          v-if="header.type === 'bool'"
          v-bind:class="!isMobile ? 'v-data-table__divider' : ''"
        >
          {{ item[header.value] ? "Да" : "Нет" }}
        </td>
        <td
          :key="header.value"
          v-else-if="header.type === 'datetime-local'"
          v-bind:class="!isMobile ? 'v-data-table__divider' : ''"
        >
          {{ dateFormatted(item[header.value]) }}
        </td>
        <td
          :key="header.value"
          v-else
          v-bind:class="!isMobile ? 'v-data-table__divider' : ''"
        >
          {{ item[header.value] }}
        </td>
      </template>
    </v-data-table>
    <!--Форма для редактирования-->
    <v-dialog
      v-if="windowsForEditOrAdd"
      v-model="windowsForEditOrAdd"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{
            action === "update" ? "Редактирование" : "Добавление"
          }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="isValid" lazy-validation>
            <table class="table-form">
              <tbody>
                <template v-for="(header, index) in headers">
                  <tr
                    v-if="
                      header.showIf != null ? selectedNoro[header.showIf] : true
                    "
                    :key="index"
                  >
                    <td style="">{{ header.text }}</td>
                    <td>
                      <v-text-field
                        rows="1"
                        v-if="header.type === 'datetime-local'"
                        outlined
                        :rules="header.rules"
                        type="datetime-local"
                        hide-details
                        no-resize
                        v-model.trim="selectedNoro[header.value]"
                      ></v-text-field>
                      <v-text-field
                        rows="1"
                        v-if="header.type === 'number'"
                        outlined
                        :rules="header.rules"
                        type="number"
                        hide-details
                        no-resize
                        v-model.number="selectedNoro[header.value]"
                      ></v-text-field>
                      <v-radio-group
                        v-if="header.type === 'bool'"
                        v-model="selectedNoro[header.value]"
                        hide-details
                      >
                        <v-radio :label="`Да`" :value="true"></v-radio>
                        <v-radio :label="`Нет`" :value="false"></v-radio>
                      </v-radio-group>
                      <v-textarea
                        v-if="header.type === 'text'"
                        :rules="header.rules"
                        rows="2"
                        outlined
                        v-model.trim="selectedNoro[header.value]"
                      ></v-textarea>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="
              windowsForEditOrAdd = false;
              selectedNoro = {};
            "
          >
            Отмена
          </v-btn>
          <v-btn
            :disabled="!isValid"
            color="blue darken-1"
            text
            @click="editOrAddRow"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Оповещение об удалении -->
    <v-dialog
      v-if="windowForDelete"
      v-model="windowForDelete"
      width="400"
      persistent
    >
      <v-card>
        <v-alert type="warning" :value="true"> Внимание</v-alert>
        <v-card-text class="text-md-center">
          Вы действительно хотите удалить данную строку?
        </v-card-text>
        <v-card-actions class="text-lg-right">
          <v-spacer />
          <v-btn
            @click="
              delayedFunction();
              windowForDelete = false;
            "
          >
            Да
          </v-btn>
          <v-btn
            @click="
              windowForDelete = false;
              delayedFunction = function () {};
            "
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { bus } from "@/main";

export default {
  name: "noro-edit-view",
  data() {
    return {
      selectedNoro: {},
      isValid: true,
      action: "",
      delayedFunction: function () {},
      windowsForEditOrAdd: false,
      windowForDelete: false,
      headers: [
        {
          text: "Наименование несанкционированного объекта размещения отходов (НОРО)",
          value: "name",
          divider: true,
          rules: [this.required],
          type: "text",
        },
        {
          text: "Тип НОРО",
          value: "typeNORO",
          rules: [this.required],
          divider: true,
          type: "text",
        },
        {
          text: "Ликвидирован",
          value: "isLiquidated",
          rules: [this.required],
          divider: true,
          type: "bool",
        },
        {
          text: "Дата ликвадации",
          value: "dateLiquidation",
          divider: true,
          rules: [this.required],
          type: "datetime-local",
          showIf: "isLiquidated",
        },
        {
          text: "Площадь (Га)",
          value: "square",
          divider: true,
          type: "number",
        },
        {
          text: "Наименование муниципального образования",
          value: "nameMunicipality",
          divider: true,
          rules: [this.required],
          type: "text",
        },
        {
          text: "Кадастровый номер (квартал)",
          value: "cadastralNumber",
          divider: true,
          type: "text",
        },
        {
          text: "Владелец земельного участка",
          value: "landOwner",
          divider: true,
          type: "text",
        },
        {
          text: "Расстояние до ближайшего населенного пункта (м)",
          value: "distanceToTown",
          divider: true,
          type: "number",
        },
        {
          text: "Категория земель",
          value: "landCategory",
          divider: true,
          rules: [this.required],
          type: "text",
        },
        {
          text: "Широта",
          value: "lat",
          rules: [this.required],
          divider: true,
          type: "number",
        },
        {
          text: "Долгота",
          value: "lon",
          divider: true,
          rules: [this.required],
          type: "number",
        },
        {
          text: "Наличие НОРО в ГРОНВОС",
          value: "availabilityInGRONVOS",
          divider: true,
          rules: [this.required],
          type: "bool",
        },
        {
          text: "Наличие НОРО в териториальной схеме размещения с отходами, в том числе с ТКО",
          value: "availabilityInTerSchema",
          divider: true,
          rules: [this.required],
          type: "bool",
        },
        {
          text: "Год основания",
          value: "dateFoundation",
          divider: true,
          type: "datetime-local",
        },
        {
          text: "Дата выявления",
          value: "dateOfInclussionInGronvos",
          divider: true,
          type: "text",
        },
        {
          text: "Примечание",
          value: "note",
          divider: true,
          type: "text",
        },
      ],
      noros: [],
      search: "",
      page: 1,
      itemsPerPage: 15,
    };
  },
  computed: {
    filteredRows() {
      if (this.noros != null) {
        let filteredRows = [];
        if (this.search.length < 3 || this.search === "") {
          filteredRows = this.noros;
          return filteredRows;
        }
        // eslint-disable-next-line no-unused-vars
        for (const row of this.noros) {
          // eslint-disable-next-line no-unused-vars
          for (const value in row) {
            if (
              row[value]
                .toString()
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) !== -1
            ) {
              filteredRows.push(row);
              break;
            }
          }
        }

        return filteredRows;
      }
      return [];
    },
  },
  methods: {
    dateFormatted(date) {
      if (date == null) {
        return;
      }
      date = date.replace("T", " ");
      date = date.replace("Z", "");
      return date;
    },
    required: (v) => {
      return !!v || "Это обязательное поле";
    },
    getHeaderTable: function (headers) {
      return [
        {
          text: "Действия",
          value: "action",
          sortable: false,
          divider: true,
        },
        ...headers,
      ];
    },
    editOrAddRow() {
      if (!this.$refs.form.validate()) {
        bus.$emit("message", {
          message: "Информация некорректна",
          color: "red",
        });
        return;
      }
      // eslint-disable-next-line no-unused-vars
      for (const key in this.selectedNoro) {
        if (this.selectedNoro[key].trim() === "") {
          this.selectedNoro[key] = null;
        }
      }
      axios
        .post(`/noro/${this.action}/`, this.selectedNoro)
        .then(() => {
          this.action = "";
          this.windowsForEditOrAdd = false;
          this.selectedNoro = {};
          this.getAllNoro();
          bus.$emit("message", {
            message: "Сохранено",
            color: "green",
          });
        })
        .catch(() => {
          bus.$emit("message", {
            message: "Не удалось внести изменения",
            color: "red",
          });
        });
    },
    // возвращает строчку из уже отфильрованных строк по индексу в таблице
    searchRowByIndex: function (index) {
      if (this.filteredRows.length === 0) {
        return null;
      }
      return this.filteredRows[(this.page - 1) * this.itemsPerPage + index];
    },
    getAllNoro() {
      axios
        .post("/noro/get/all")
        .then((noroData) => {
          this.noros = noroData.data;
        })
        .catch(() => {
          bus.$emit("message", {
            message: "Не удалось получить объекты",
            color: "red",
          });
        });
    },
    deleteNoro: function (id) {
      axios
        .post("/noro/delete", {}, { params: { id: id } })
        .then(() => {
          this.getAllNoro();
          bus.$emit("message", {
            message: "Объект удален",
            color: "green",
          });
        })
        .catch(() => {
          bus.$emit("message", {
            message: "Не удалось удалить объект",
            color: "red",
          });
        });
    },
    getNoro: function (id) {
      return new Promise((resolve, reject) => {
        axios
          .post("/noro/get", {}, { params: { id: id } })
          .then((noroData) => {
            this.selectedNoro = noroData.data;
            resolve();
          })
          .catch(() => {
            bus.$emit("message", {
              message: "Не удалось получить объект",
              color: "red",
            });
            reject();
          });
      });
    },
  },
  async mounted() {
    if (this.$route.params.id !== undefined) {
      await this.getNoro(this.$route.params.id);
      this.action = "update";
      this.windowsForEditOrAdd = true;
    }
    this.getAllNoro();
  },
};
</script>

<style scoped>
.v-input--selection-controls {
  margin-top: 0px !important;
}

.table-form {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  height: auto;
}

.table-form td,
th {
  word-wrap: break-word;
  border: 1px solid #595959;
  padding: 5px;
}

v-textarea {
  height: 100%;
}
</style>
